import React, { useState, useEffect } from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import api, { absUrl } from '../../services/api';
import '../../styles/stickers.css';

function defaultEmojiFor(packName) {
  const map = { smileys: '😀', animals: '🐾', food: '🍕', objects: '💡', symbols: '✨' };
  return map[packName] || '✨';
}

export default function EmojiPicker({ onSelect, onSticker, onClose }) {
  const [tab, setTab] = useState('emoji');
  const [packs, setPacks] = useState([]);
  const [selectedPack, setSelectedPack] = useState(null);
  const [stickers, setStickers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchEmoji, setSearchEmoji] = useState('');

  useEffect(() => {
    if (tab === 'stickers' && packs.length === 0) loadPacks();
  }, [tab]);

  const loadPacks = async () => {
    setLoading(true);
    try {
      const res = await api.get('/stickers/packs');
      setPacks(res.data);
      if (res.data.length > 0) {
        setSelectedPack(res.data[0]);
        loadStickers(res.data[0].id);
      }
    } catch (err) {
      console.error('Failed to load sticker packs:', err);
    }
    setLoading(false);
  };

  const loadStickers = async (packId) => {
    try {
      const res = await api.get(`/stickers/packs/${packId}`);
      setStickers(res.data);
    } catch (err) {
      console.error('Failed to load stickers:', err);
    }
  };

  const handlePackSelect = (pack) => {
    setSelectedPack(pack);
    loadStickers(pack.id);
  };

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchEmoji(value);
    if (value && value.trim().length > 0) {
      try {
        const res = await api.get('/stickers/search', { params: { emoji: value.trim() } });
        setStickers(res.data);
      } catch (err) {
        console.error('Sticker search failed:', err);
      }
    } else {
      if (selectedPack) loadStickers(selectedPack.id);
    }
  };

  return (
    <div className="emoji-picker-overlay" onClick={onClose}>
      <div className="emoji-panel" onClick={(e) => e.stopPropagation()}>
        <div className="emoji-panel-tabs">
          <button className={`emoji-panel-tab ${tab === 'emoji' ? 'active' : ''}`} onClick={() => setTab('emoji')}>
            😊 Эмодзи
          </button>
          {onSticker && (
            <button className={`emoji-panel-tab ${tab === 'stickers' ? 'active' : ''}`} onClick={() => setTab('stickers')}>
              🎨 Стикеры
            </button>
          )}
        </div>
        {tab === 'emoji' ? (
          <Picker data={data} onEmojiSelect={(emoji) => { onSelect(emoji.native); onClose(); }} />
        ) : (
          <div className="emoji-panel-stickers">
            {loading && <div className="sticker-picker-loading">Загрузка стикеров...</div>}
            <div className="sticker-search-row">
              <input
                type="text"
                className="sticker-search-input"
                placeholder="🔍 Поиск по смайлику"
                value={searchEmoji}
                onChange={handleSearch}
              />
            </div>
            <div className="sticker-packs-tabs">
              {packs.map((pack) => (
                <div key={pack.id}
                  className={`sticker-pack-tab ${selectedPack?.id === pack.id ? 'active' : ''}`}
                  onClick={() => handlePackSelect(pack)}
                  title={pack.title}>
                  <span className="pack-emoji">{defaultEmojiFor(pack.name)}</span>
                  {pack.title && <span className="pack-tab-title">{pack.title}</span>}
                </div>
              ))}
            </div>
            <div className="sticker-grid">
              {stickers.map((sticker) => (
                <div key={sticker.id} className="sticker-item"
                  onClick={() => { onSticker(sticker.imageUrl); onClose(); }}>
                  <img src={absUrl(sticker.imageUrl)} alt={sticker.emoji || ''} className="sticker-image" />
                  {sticker.emoji && <span className="sticker-emoji-badge">{sticker.emoji}</span>}
                </div>
              ))}
              {stickers.length === 0 && !loading && (
                <div className="sticker-empty">
                  {searchEmoji ? 'По этому смайлику стикеров не найдено' : 'Нет стикеров в этом пакете'}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}